import React from 'react'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { usePayoutPopupContext } from '../context'
import { useCompensationPopupStyles } from '../styles'
import PayoutLabel from '../components/PayoutLabel'
import { getLabelValueWithPrefix } from '../../../utils/getLabelValue'

const AnnualTeamBonusRelatedAmount = () => {
  const classes = useStyles()
  const commonClasses = useCompensationPopupStyles()
  const { t } = useTranslation()
  const { data } = usePayoutPopupContext()

  if (!data) {
    return null
  }

  const bonusRateLabelClassName = {
    label: clsx(commonClasses.labelAsAccordion, classes.bonusRateLabel),
    value: clsx(commonClasses.labelAsAccordion, classes.bonusRateLabel),
  }

  return (
    <>
      <ul className={classes.bonusRateList}>
        <li>
          <PayoutLabel
            classes={bonusRateLabelClassName}
            label={t('compensation_popup_team_annual_revenue_label')}
            value={getLabelValueWithPrefix(data.annualPayout?.teamBonus?.teamAnnualRevenue ?? 0)}
            format="euroInt"
          />
        </li>
        <li>
          <PayoutLabel
            classes={bonusRateLabelClassName}
            label={t('compensation_popup_team_revenue_threshold_label')}
            value={-(data.annualPayout?.teamBonus?.teamRevenueThreshold ?? 0)}
            format="euroInt"
          />
        </li>
      </ul>
    </>
  )
}

export default AnnualTeamBonusRelatedAmount

const useStyles = makeStyles({
  bonusRateList: {
    margin: 0,
    marginBottom: 4,
  },
  bonusRateLabel: {
    paddingLeft: 0,
    paddingTop: 4,
    paddingBottom: 4,
    fontSize: 13,
  },
})
